import { Pipe, PipeTransform } from '@angular/core';
import { ResourceService } from '../../services/resource.service';

@Pipe({
    name: 'resource'
})
export class ResourcePipe implements PipeTransform
{
    private resourceService: ResourceService;

    public constructor(resourceService: ResourceService)
    {
        this.resourceService = resourceService;
    }

    public transform<T>(key: string): string
    {
        return this.resourceService.getString(key);
    }
}


